module.exports = __webpack_public_path__ + "assets/23a4241b454d3af4f5a6e1502e0b32ee.svg";